// Gate dApp 钱包兼容性检查和处理
export function isGateWallet(): boolean {
  if (typeof window === 'undefined') return false
  // 检查是否是 Gate dApp
  const userAgent = navigator.userAgent.toLowerCase()
  return userAgent.includes('gate') || userAgent.includes('gate.io')
}

export function getGateWalletProvider(): any {
  if (typeof window === 'undefined') return null

  // Gate dApp 可能使用不同的注入方式
  if ((window as any).ethereum) {
    return (window as any).ethereum
  }

  // 检查其他可能的注入方式
  if ((window as any).gatewallet) {
    return (window as any).gatewallet
  }

  if ((window as any).web3?.currentProvider) {
    return (window as any).web3.currentProvider
  }

  return null
}

export async function switchNetworkInGate(chainId: number): Promise<boolean> {
  const provider = getGateWalletProvider()
  if (!provider) return false
  try {
    // 方法1: 尝试标准方法
    if (provider.request) {
      await provider.request({
        method: 'wallet_switchEthereumChain',
        params: [{ chainId: `0x${chainId.toString(16)}` }]
      })
      return true
    }
    // 方法2: 尝试旧版方法
    if (provider.send) {
      await provider.send('wallet_switchEthereumChain', [{ chainId: `0x${chainId.toString(16)}` }])
      return true
    }
    // 方法3: 尝试直接设置
    if (provider.setNetwork) {
      await provider.setNetwork(chainId)
      return true
    }
    // 方法4: 尝试通过事件触发
    if (provider.chainId !== `0x${chainId.toString(16)}`) {
      const event = new CustomEvent('chainChanged', { detail: `0x${chainId.toString(16)}` })
      window.dispatchEvent(event)
      return true
    }
    return false
  } catch (error) {
    console.warn('Gate wallet network switch failed:', error)
    return false
  }
}
